import { Rule } from 'rc-field-form/lib/interface';
import { tenantFormFields } from 'src/utils/constants';
import { defineMessages } from 'react-intl';
import { getIntl } from 'src/utils/languageUtils';

const messages = defineMessages({
  criteriaValidation: {
    id: 'SiteGroups.validators.criteriaValidation',
    defaultMessage: 'At least one criteria need to be selected',
  },
});
const intl = getIntl(messages);
export const criteriaValidator = (): Rule[] => [
  ({ getFieldValue }) => ({
    validator() {
      if (
        !(getFieldValue(tenantFormFields.OPERATOR_ID) as [])?.length &&
        !(getFieldValue(tenantFormFields.STATE) as [])?.length &&
        !(getFieldValue(tenantFormFields.COUNTRY_CRITERIA) as [])?.length &&
        !(getFieldValue(tenantFormFields.SITES) as [])?.length &&
        !getFieldValue(tenantFormFields.ALL_SITES)
      ) {
        return Promise.reject(intl.formatMessage(messages.criteriaValidation));
      }
      return Promise.resolve();
    },
  }),
];
